import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "OK ", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_4 = { class: "ant-col ant-col-xs-20 ant-col-xl-14" }
const _hoisted_5 = { class: "ant-col ant-col-xs-4 ant-col-xl-2 ss-display-flex-end" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar nova inscrição", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      closable: false,
      maskClosable: false
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Inscrição Estadual - Substituição Tributária ")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvarInscricoes && _ctx.salvarInscricoes(...args)))
          }, _hoisted_2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          name: "form-gerenciar-iest",
          model: _ctx.stateModal
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateModal.inscricoes, (inscricao, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ant-row",
                key: inscricao.codigo,
                style: {"display":"flex","margin-bottom":"8px"}
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_a_form_item, {
                    name: ['inscricoes', index, 'codigoEstado'],
                    label: "Estado"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: inscricao.codigoEstado,
                        "onUpdate:value": ($event: any) => ((inscricao.codigoEstado) = $event),
                        options: _ctx.stateModal.listaEstados,
                        optionFilterProp: "label",
                        "show-search": true,
                        placeholder: "Selecione",
                        style: {"width":"95%"}
                      }, null, 8, ["value", "onUpdate:value", "options"])
                    ]),
                    _: 2
                  }, 1032, ["name"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_form_item, {
                    label: "Inscrição",
                    name: ['inscricoes', index, 'inscricaoEstadual']
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: inscricao.inscricaoEstadual,
                        "onUpdate:value": ($event: any) => ((inscricao.inscricaoEstadual) = $event),
                        maxlength: "14"
                      }, null, 8, ["value", "onUpdate:value"])
                    ]),
                    _: 2
                  }, 1032, ["name"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-primary ant-btn-dangerous",
                    style: {"width":"30px","padding":"4px 4px"},
                    onClick: ($event: any) => (_ctx.removerInscricao(inscricao))
                  }, "X", 8, _hoisted_6)
                ])
              ]))
            }), 128)),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-dashed ant-btn-block",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.adicionarInscricao && _ctx.adicionarInscricao(...args)))
                }, _hoisted_8)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}